import {DatabaseCode, toDatabaseCode, toDatabaseCodeSafely} from "../database-code";

export type RrcWasteType = DatabaseCode;

const type01: RrcWasteType = {
  code: "01",
  displayValue: {
    id: "common.entity.rrcwastetype.type01",
    defaultMessage: "01 - Cement Contaminated Fluid",
  },
};

const type02: RrcWasteType = {
  code: "02",
  displayValue: {
    id: "common.entity.rrcwastetype.type02",
    defaultMessage: "02 - Completion Fluids",
  },
};

const type03: RrcWasteType = {
  code: "03",
  displayValue: {
    id: "common.entity.rrcwastetype.type03",
    defaultMessage: "03 - Condensate/Crude Oil",
  },
};

const type04: RrcWasteType = {
  code: "04",
  displayValue: {
    id: "common.entity.rrcwastetype.type04",
    defaultMessage: "04 - Contaminated Soil",
  },
};

const type05: RrcWasteType = {
  code: "05",
  displayValue: {
    id: "common.entity.rrcwastetype.type05",
    defaultMessage: "05 - Used Filters and Filter Media",
  },
};

const type06: RrcWasteType = {
  code: "06",
  displayValue: {
    id: "common.entity.rrcwastetype.type06",
    defaultMessage: "06 - Fluid Returns with Frac Sand",
  },
};

const type07: RrcWasteType = {
  code: "07",
  displayValue: {
    id: "common.entity.rrcwastetype.type07",
    defaultMessage: "07 - Formation Fines/Solids",
  },
};

const type08: RrcWasteType = {
  code: "08",
  displayValue: {
    id: "common.entity.rrcwastetype.type08",
    defaultMessage: "08 - Fresh Water",
  },
};

const type09: RrcWasteType = {
  code: "09",
  displayValue: {
    id: "common.entity.rrcwastetype.type09",
    defaultMessage: "09 - Gas Plant Waste Solids",
  },
};

const type10: RrcWasteType = {
  code: "10",
  displayValue: {
    id: "common.entity.rrcwastetype.type10",
    defaultMessage: "10 - Gas Plant Waste Liquids",
  },
};

const type11: RrcWasteType = {
  code: "11",
  displayValue: {
    id: "common.entity.rrcwastetype.type11",
    defaultMessage: "11 - Oil Based Cuttings",
  },
};

const type12: RrcWasteType = {
  code: "12",
  displayValue: {
    id: "common.entity.rrcwastetype.type12",
    defaultMessage: "12 - Oil Based Mud",
  },
};

const type13: RrcWasteType = {
  code: "13",
  displayValue: {
    id: "common.entity.rrcwastetype.type13",
    defaultMessage: "13 - Pipeline Water and Waste",
  },
};

const type14: RrcWasteType = {
  code: "14",
  displayValue: {
    id: "common.entity.rrcwastetype.type14",
    defaultMessage: "14 - Pit Liners",
  },
};

const type15: RrcWasteType = {
  code: "15",
  displayValue: {
    id: "common.entity.rrcwastetype.type15",
    defaultMessage: "15 - Rubbish",
  },
};

const type16: RrcWasteType = {
  code: "16",
  displayValue: {
    id: "common.entity.rrcwastetype.type16",
    defaultMessage: "16 - Pit Water",
  },
};

const type17: RrcWasteType = {
  code: "17",
  displayValue: {
    id: "common.entity.rrcwastetype.type17",
    defaultMessage: "17 - Produced Sands/Solids",
  },
};

const type18: RrcWasteType = {
  code: "18",
  displayValue: {
    id: "common.entity.rrcwastetype.type18",
    defaultMessage: "18 - Produced Water",
  },
};

const type19: RrcWasteType = {
  code: "19",
  displayValue: {
    id: "common.entity.rrcwastetype.type19",
    defaultMessage: "19 - Production Pit Sludge",
  },
};

const type20: RrcWasteType = {
  code: "20",
  displayValue: {
    id: "common.entity.rrcwastetype.type20",
    defaultMessage: "20 - Rainwater",
  },
};

const type21: RrcWasteType = {
  code: "21",
  displayValue: {
    id: "common.entity.rrcwastetype.type21",
    defaultMessage: "21 - Tank Bottoms",
  },
};

const type22: RrcWasteType = {
  code: "22",
  displayValue: {
    id: "common.entity.rrcwastetype.type22",
    defaultMessage: "22 - Washout Water",
  },
};

const type23: RrcWasteType = {
  code: "23",
  displayValue: {
    id: "common.entity.rrcwastetype.type23",
    defaultMessage: "23 - Water Based Cuttings",
  },
};

const type24: RrcWasteType = {
  code: "24",
  displayValue: {
    id: "common.entity.rrcwastetype.type24",
    defaultMessage: "24 - Water Based Mud",
  },
};

const type25: RrcWasteType = {
  code: "25",
  displayValue: {
    id: "common.entity.rrcwastetype.type25",
    defaultMessage: "25 - Synthetic Based Cuttings",
  },
};

const type26: RrcWasteType = {
  code: "26",
  displayValue: {
    id: "common.entity.rrcwastetype.type26",
    defaultMessage: "26 - Synthetic Based Mud",
  },
};

const type27: RrcWasteType = {
  code: "27",
  displayValue: {
    id: "common.entity.rrcwastetype.type27",
    defaultMessage: "27 - Inert Oil & Gas Waste",
  },
};

const type28: RrcWasteType = {
  code: "28",
  displayValue: {
    id: "common.entity.rrcwastetype.type28",
    defaultMessage: "28 - Other Aqueous Waste",
  },
};

const type29: RrcWasteType = {
  code: "29",
  displayValue: {
    id: "common.entity.rrcwastetype.type29",
    defaultMessage: "29 - Other Solid Waste",
  },
};

const type30: RrcWasteType = {
  code: "30",
  displayValue: {
    id: "common.entity.rrcwastetype.type30",
    defaultMessage: "30 - Other Pipeline Waste",
  },
};

const type31: RrcWasteType = {
  code: "31",
  displayValue: {
    id: "common.entity.rrcwastetype.type31",
    defaultMessage: "31 - Other* (Description required)",
  },
};

export const rrcWasteType = {
  type01,
  type02,
  type03,
  type04,
  type05,
  type06,
  type07,
  type08,
  type09,
  type10,
  type11,
  type12,
  type13,
  type14,
  type15,
  type16,
  type17,
  type18,
  type19,
  type20,
  type21,
  type22,
  type23,
  type24,
  type25,
  type26,
  type27,
  type28,
  type29,
  type30,
  type31,
};

export const rrcWasteTypes: RrcWasteType[] = Object.values(rrcWasteType);

export const toRrcWasteType = (code: string): RrcWasteType =>
  toDatabaseCode(code, rrcWasteTypes);

export const toRrcWasteTypeSafely = (
  code: string | undefined,
  defaultValue: RrcWasteType | undefined = undefined
): RrcWasteType | undefined => toDatabaseCodeSafely(code, rrcWasteTypes, defaultValue);
